"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _api = require("@react-google-maps/api");
var _geolib = require("geolib");
var _dictionary = require("@otpusk/json-api/dist/dictionary");
var _useSupercluster2 = _interopRequireDefault(require("use-supercluster"));
var _config = require("../../services/config");
var _Cluster = require("./components/Cluster");
var _MarkerByStars = _interopRequireDefault(require("./components/MarkerByStars"));
var _PricePopup = _interopRequireDefault(require("./components/PricePopup"));
var _selectors = require("./store/selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var CONTAINER_STYLES = {
  width: '100%',
  height: '100%'
};
var normalizrCoordsToGeoLib = R.applySpec({
  latitude: R.prop('lat'),
  longitude: R.prop('lng')
});
var computeRadius = function computeRadius(pointA, pointB) {
  return R.call(R.pipe(_geolib.getDistance, function (meters) {
    return (0, _geolib.convertDistance)(meters, 'km');
  }), normalizrCoordsToGeoLib(pointA), normalizrCoordsToGeoLib(pointB));
};
var shouldFitBounds = function shouldFitBounds(markers, zoom) {
  return markers.length > 1 && !zoom;
};
var getRadius = function getRadius(mapInstance) {
  return mapInstance.getBounds().getNorthEast().toJSON();
};
var Map = function Map(_ref) {
  var activeCurrencyCode = _ref.activeCurrencyCode,
    initialActivePrice = _ref.activePrice,
    center = _ref.center,
    markers = _ref.markers,
    initialZoom = _ref.zoom,
    onClickByActivePrice = _ref.onClickByActivePrice,
    onRadiusChange = _ref.onRadiusChange;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    map = _useState2[0],
    setMap = _useState2[1];
  var _useState3 = (0, _react.useState)(initialActivePrice),
    _useState4 = _slicedToArray(_useState3, 2),
    activePrice = _useState4[0],
    setActivePrice = _useState4[1];
  var _useState5 = (0, _react.useState)(initialZoom),
    _useState6 = _slicedToArray(_useState5, 2),
    zoom = _useState6[0],
    setZoom = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    bounds = _useState8[0],
    setBounds = _useState8[1];
  var language = (0, _reactRedux.useSelector)(_selectors.getLanguage);
  var _useJsApiLoader = (0, _api.useJsApiLoader)({
      id: 'google-map-script',
      googleMapsApiKey: (0, _config.getGoogleMapApiKey)(),
      language: language
    }),
    isLoaded = _useJsApiLoader.isLoaded,
    loadError = _useJsApiLoader.loadError;
  var points = (0, _react.useMemo)(function () {
    return R.map(function (marker) {
      return {
        type: 'Feature',
        properties: _objectSpread({}, marker),
        geometry: {
          type: 'Point',
          coordinates: [marker.position.lng, marker.position.lat]
        }
      };
    }, markers);
  }, [markers]);
  var _useSupercluster = (0, _useSupercluster2.default)({
      points: points,
      bounds: bounds,
      zoom: zoom,
      options: {
        radius: 75,
        maxZoom: 18
      }
    }),
    clusters = _useSupercluster.clusters;
  var currency = (0, _react.useMemo)(function () {
    return (0, _dictionary.getCurrencyByCode)(activeCurrencyCode);
  }, [activeCurrencyCode]);
  var handleOnZoomChanged = (0, _react.useCallback)(function () {
    if (map) {
      setZoom(map.getZoom());
      onRadiusChange(computeRadius(center, getRadius(map)));
    }
  }, [center, map, onRadiusChange]);
  var resetActivePrice = (0, _react.useCallback)(function () {
    return setActivePrice(null);
  }, []);
  var handleLoad = (0, _react.useCallback)(function (mapInstance) {
    if (shouldFitBounds(markers, zoom)) {
      var _bounds = R.reduce(function (acc, marker) {
        return acc.extend(new global.window.google.maps.LatLng(marker.position.lat, marker.position.lng));
      }, new global.window.google.maps.LatLngBounds(), markers);
      mapInstance.fitBounds(_bounds);
    }
    setMap(mapInstance);
  }, [markers, zoom]);
  var onBoundsChanged = (0, _react.useCallback)(function () {
    if (map) {
      var _bounds = map.getBounds();
      var ne = _bounds.getNorthEast();
      var sw = _bounds.getSouthWest();
      setBounds([sw.lng(), sw.lat(), ne.lng(), ne.lat()]);
    }
  }, [map]);
  return isLoaded && (loadError ? loadError || 'Fatal google api map error' : /*#__PURE__*/_react.default.createElement(_api.GoogleMap, {
    center: center,
    mapContainerStyle: CONTAINER_STYLES,
    zoom: zoom,
    onClick: resetActivePrice,
    onLoad: handleLoad,
    onZoomChanged: handleOnZoomChanged,
    onBoundsChanged: onBoundsChanged
  }, R.map(function (_ref2) {
    var geometry = _ref2.geometry,
      properties = _ref2.properties;
    var cluster = properties.cluster,
      clusterID = properties.cluster_id,
      hotelID = properties.hotelID,
      offerID = properties.offerID,
      position = properties.position,
      props = properties.props,
      pointCount = properties.point_count;
    if (cluster) {
      var _geometry$coordinates = _slicedToArray(geometry.coordinates, 2),
        longitude = _geometry$coordinates[0],
        latitude = _geometry$coordinates[1];
      return /*#__PURE__*/_react.default.createElement(_Cluster.Cluster, {
        count: pointCount,
        key: clusterID,
        position: {
          lat: latitude,
          lng: longitude
        }
      });
    }
    return /*#__PURE__*/_react.default.createElement(_MarkerByStars.default, _extends({}, props, {
      active: R.prop('hotelID', initialActivePrice) === hotelID,
      key: hotelID,
      position: position,
      onClick: function onClick() {
        return setActivePrice({
          hotelID: hotelID,
          offerID: offerID
        });
      }
    }));
  }, clusters), activePrice && /*#__PURE__*/_react.default.createElement(_PricePopup.default, {
    currency: currency,
    hotelID: activePrice.hotelID,
    offerID: activePrice.offerID,
    onClick: onClickByActivePrice,
    onClose: resetActivePrice
  })));
};
Map.propTypes = {
  markers: _propTypes.default.arrayOf(_propTypes.default.shape({
    hotelID: _propTypes.default.string.isRequired,
    position: _propTypes.default.object.isRequired,
    props: _propTypes.default.object
  })).isRequired,
  activeCurrencyCode: _propTypes.default.string,
  activePrice: _propTypes.default.exact({
    hotelID: _propTypes.default.string.isRequired,
    offerID: _propTypes.default.string
  }),
  center: _propTypes.default.exact({
    lat: _propTypes.default.number.isRequired,
    lng: _propTypes.default.number.isRequired
  }),
  zoom: _propTypes.default.number,
  onClickByActivePrice: _propTypes.default.func,
  onRadiusChange: _propTypes.default.func
};
Map.defaultProps = {
  activeCurrencyCode: 'uah',
  markers: [],
  onRadiusChange: function onRadiusChange() {}
};
var _default = exports.default = (0, _react.memo)(Map);